import React from "react";

export function Spinner({ size = 16, color = "var(--kr-action)", style }) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `2px solid ${color}`,
        borderRightColor: "transparent",
        borderRadius: "50%",
        animation: "kr-spin 0.7s linear infinite",
        ...(style || {}),
      }}
    />
  );
}

if (typeof document !== "undefined" && !document.getElementById("kr-spin-keyframes")) {
  const style = document.createElement("style");
  style.id = "kr-spin-keyframes";
  style.textContent = "@keyframes kr-spin{to{transform:rotate(360deg)}}";
  document.head.appendChild(style);
}

export default Spinner;
